// src/screens/Instrucoes/Instrucoes.js (Versão Atualizada)

import React from 'react';
import { Link, useNavigate } from 'react-router-dom'; // Importa o useNavigate
import { FaArrowLeft } from 'react-icons/fa'; // Importa o ícone de seta
import './Instrucao.css'; 
import manualIcon from '../../assets/manual.png';

const Instrucoes = () => {
  const navigate = useNavigate(); // Hook para controlar a navegação

  return (
    <div className="instrucoes-container">
      <div className="instrucoes-card">
        
        {/* BOTÃO DE VOLTAR ADICIONADO AQUI */}
        <button onClick={() => navigate(-1)} className="instrucoes-back-button">
          <FaArrowLeft /> Voltar
        </button>
        
        <div className="instrucoes-icon-container">
          <img src={manualIcon} alt="Ícone de Instruções" className="instrucoes-icon" />
        </div>
        
        <h1 className="instrucoes-title">Instruções de Uso</h1>

        <div className="instrucoes-content">
          <p>
            O aplicativo pode ser usado para cálculo mensal, ou qualquer outro período desejado. Recomenda-se que seja usado mensalmente, uma vez que os valores em reais gastos estão frescos na cabeça do produtor. Todos os gastos são expressos em real.
          </p>
          <p>
            O aplicativo serve, também, para realizar simulações, uma vez que o produtor pode alterar qualquer valor nele. Altera valor, calcula, salva e compartilha para o WhatsApp, assim poderá ter o registro e quantas simulações desejar, além do custo de produção operacional e total e rentabilidade reais.
          </p>
          
          <h2>Estrutura do Aplicativo</h2>
          <p>
            Como pode ver, o aplicativo está estruturado em 5 telas principais:
          </p>
          
          <div className="instrucoes-step">
            <h3>1. Produção e Produtividade</h3>
            <p>
              A primeira tela é para o produtor registrar seus dados de produção e mandar o aplicativo calcular. Feito isto o aplicativo fornecerá os dados de produtividade. Se o produtor mudar os dados de produção e mandar o aplicativo calcular, novos dados de produtividade serão gerados. Sempre que fizer um cálculo o produtor deve clicar em compartilhar salvando um arquivo PDF.
            </p>
          </div>

          <div className="instrucoes-step">
            <h3>2. Custo de Capital e Depreciação</h3>
            <p>
              Na segunda tela, o produtor deve digitar os valores do capital investido em benfeitorias, máquinas e equipamentos, valor da terra, do rebanho, e as taxas de remuneração e depreciação. Se for mensal, as taxas podem ser de 1% ou mais. Se for anual, pode ser 12% para remuneração e 10% para depreciação. Ao calcular, o custo de oportunidade do capital e a depreciação serão obtidos.
            </p>
          </div>

          <div className="instrucoes-step">
            <h3>3. Custo Operacional e Total</h3>
            <p>
              A terceira tela é para registro dos gastos com a produção: pastagens, concentrados, mão-de-obra, despesas financeiras (juros, amortizações) e outros custos (inseminação, vacinas, energia, etc.). Ao calcular, gera-se o custo operacional total e por litro, e o custo total e por litro.
            </p>
          </div>

          <div className="instrucoes-step">
            <h3>4. Receita e Rentabilidade</h3>
            <p>
              A quarta tela registra o total do leite vendido, preço, e outras vendas (animais, queijo, etc.). Ao calcular, gera a receita, lucro operacional e líquido. Também calcula a rentabilidade do capital (se maior que 100%, é um bom negócio) e o ponto de equilíbrio (produção necessária para cobrir todos os custos).
            </p>
          </div>

          <div className="instrucoes-step">
            <h3>5. Relatório Final</h3>
            <p>
              A quinta tela gera o relatório final com todos os cálculos agregados. Em qualquer tela de cálculo, o produtor pode clicar em "Compartilhar" para gerar um arquivo PDF e enviar via WhatsApp ou outras opções.
            </p>
          </div>
          
          <p className="instrucoes-footer-text">
            Para mais informações, <Link to="/contatos">entre em contato conosco</Link> ou visite nosso site.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Instrucoes;